// TODO: Convert this file to TS, once next types have been updated
import getConfig from "next/config";
const config = getConfig();

// Remove trailing slash from URL, so we can join it like this: `${API_BASE_URL}/foo/bar`
export const API_BASE_URL =
  config && config.publicRuntimeConfig
    ? config.publicRuntimeConfig.API_BASE_URL.replace(/\/+$/, "")
    : "https://stat.stadt-zuerich.ch/api"; // Should only apply to Catalog;



// WEBPACK FOOTER //
// ./src/config.js